export const APP_EVENTS = {
    onInit: "mng.auth.onInit",    
    onFinished: "mng.auth.onFinished",
    onReady: "mng.auth.onReady",
    onFatalException: "mng.auth.onFatalException",
    onAuthStarted: "mng.auth.onAuthStarted",
    onAuthDetermined: "mng.auth.onAuthDetermined",
    onScriptLoadStart: "mng.auth.onScriptLoadStart",
    onScriptLoadEnd: "mng.auth.onScriptLoadEnd",
    onLoginStarted:"mng.auth.onLoginStarted",
    onLogin:"mng.auth.onLogin",
    onRegisterStarted:"mng.auth.onRegisterStarted",
    onRegister:"mng.auth.onRegister",
    onLoggedIn:"mng.auth.onLoggedIn",
    onLogout:"mng.auth.onLogout",
    onEntitlementStarted: "mng.auth.onEntitlementStarted",
    onEntitlementsDetermined: "mng.auth.onEntitlementsDetermined",
    onPagesuiteReady: "mng.auth.onPagesuiteReady",
    onPagesuiteContentChanged: "mng.auth.onPagesuiteContentChanged",
    onDisplayShown: "mng.auth.onDisplayShown",
    onDisplayHidden: "mng.auth.onDisplayHidden",
    onScreenShown: "mng.auth.onScreenShown",
    onScreenHidden: "mng.auth.onScreenHidden",
    onOneTapPrompted: "mng.auth.onOneTapPrompted",
    onOneTapLoginStarted: "mng.auth.onOneTapLoginStarted",
    onLegacyEntitlementsReady: "entitlementsReady",
    onLegacyAuthenticationReady: "authenticationReady",
    
} as const;
